import React from 'react'

function TimerIcon() {
  return (
    <svg
      width="79"
      height="78"
      viewBox="0 0 79 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="39.5" cy="39" r="39" fill="#FA7C00" />
      <path
        d="M33.3333 52.5H46V47.75C46 46.0083 45.3799 44.5174 44.1396 43.2771C42.8993 42.0368 41.4083 41.4167 39.6667 41.4167C37.925 41.4167 36.434 42.0368 35.1938 43.2771C33.9535 44.5174 33.3333 46.0083 33.3333 47.75V52.5ZM39.6667 38.25C41.4083 38.25 42.8993 37.6299 44.1396 36.3896C45.3799 35.1493 46 33.6583 46 31.9167V27.1667H33.3333V31.9167C33.3333 33.6583 33.9535 35.1493 35.1938 36.3896C36.434 37.6299 37.925 38.25 39.6667 38.25ZM27 55.6667V52.5H30.1667V47.75C30.1667 46.1403 30.5427 44.6295 31.2948 43.2177C32.0469 41.8059 33.0958 40.6778 34.4417 39.8333C33.0958 38.9889 32.0469 37.8608 31.2948 36.449C30.5427 35.0372 30.1667 33.5264 30.1667 31.9167V27.1667H27V24H52.3333V27.1667H49.1667V31.9167C49.1667 33.5264 48.7906 35.0372 48.0385 36.449C47.2865 37.8608 46.2375 38.9889 44.8917 39.8333C46.2375 40.6778 47.2865 41.8059 48.0385 43.2177C48.7906 44.6295 49.1667 46.1403 49.1667 47.75V52.5H52.3333V55.6667H27Z"
        fill="white"
      />
    </svg>
  )
}

export default TimerIcon
